import React from 'react'
import styled from 'styled-components'
import logoDemo from '../../assets/img/logo.svg'

/**
* @author zilahir
* @function Supporters
**/

const LogoContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding: 50px;
`

const OneLogo = styled.div`
	display: flex;
	flex: 1 0 33%;
	justify-content: center;
	padding: 50px;
	@media (max-width: 768px) {
		padding: 0;
		margin-bottom: 70px;
  	}
`

const LogoImage = styled.img`
	opacity: 0.5;
`

const Supporters = (props) => {
	return(
		<section id="five" className="wrapper style3 fade-up">
			<div className="inner">
				<h2>Supporters</h2>
				<LogoContainer>
					{
						Array(10).fill().map((curr, i) => (
							<OneLogo>
								<LogoImage src={logoDemo} />
							</OneLogo>
						))
					}
				</LogoContainer>
			</div>
		</section>
	 )

 }

export default Supporters